export default "__VITE_ASSET__42643b4b__"